exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--MRXrISanKV6Q_i-zvVAI8 {\n  grid-template-columns: 248px repeat(4, minmax(min-content, auto)) minmax(164px, max-content) repeat(3, minmax(min-content, max-content));\n}\n", ""]);

// exports
exports.locals = {
	"listViewContainer": "care-team-tasks--MRXrISanKV6Q_i-zvVAI8",
	"listViewContainer": "care-team-tasks--MRXrISanKV6Q_i-zvVAI8"
};